import {
  // Avatar, Button,
  Card, CardContent, CardActions, Typography,
  // Stack, Chip,
  Box, Grid, CardMedia, styled, Link
} from '@mui/material';
// import Link from 'next/link';
// import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// import { readingTime } from '../../utils/helpers';
// import { getRandomStr } from '../../../../helpers';
import { useRouter } from 'next/router';

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.primary.main,
//     // color: 'rgba(0, 0, 0, 0.87)',
//     color: '#fff',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));

const StyledCard = styled(Card)`
  cursor: pointer;
  overflow: hidden;
  img { transition: transform 300ms ease-in-out; }
  &:hover img { transform: scale(1.02); }`;

export default function TopIdea({ post, index }) {
  const router = useRouter();

  const convertTime12to24 = time12h => {
    const [time, modifier] = time12h?.split(' ');
    let [hours, minutes, seconds] = time ? time.split(':') : null;
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replase = n.replace(new RegExp(',', 'g'), ' ')
    return `${replase} • ${convertTime12to24(t)}`
  }

  return (
    <>
      {/* <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 3 }}
      > */}
      <Grid size={{ md: 12, xs: 12, sm: 12 }}>
        {/*{posts && posts.length > 0 ? posts.slice(0, dataConstants.TOP_IDEA).map((post, index) => {
          return ( */}
        <Link underline="none" href={`/stock-ideas/${post.slug}`}>
          <StyledCard key={index} className={post?.frontmatter?.tags?.find(d => d === 'premium') ? 'premium-blog' : 'blog'}
            onClick={() => router.push(`/stock-ideas/${post.slug}`)}
            sx={{
              // maxWidth: 650,
              height: '100%',
              // '&:hover': { background: '#fff', boxShadow: '0 3px 5px rgba(132,135,154,.2), 0 1px 1px rgba(132,135,154,.2)' },
              border: '1px solid #F3F4F5',
              cursor: 'pointer', p: '12pxx', borderRadius: '8px', boxShadow: 0,
              // display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
              // bgcolor: (post?.frontmatter?.tags?.find(d => d === 'premium') || (index === 0 || index === 1)) ? '#f8f9fa' : 'transparent'
              // display: 'flex', flexDirection: { md: 'row', sm: 'column', xs: 'column' }, overflow: 'hidden',
            }}
          >
            <CardMedia
              sx={{
                background: '#f8f9fa', backgroundImage: `url(${post?.frontmatter?.cover_image})`,
                backgroundSize: 'cover', backgroundPosition: "center", backgroundRepeat: 'no-repeat',
                height: { md: '465px' }, borderRadius: { md: '8px' }, p: '0 !important', display: 'flex', flexDirection: 'column',
                alignItems: 'end', justifyContent: 'end'
              }}>
              <Box component="div" className='post-desc'
                sx={{
                  color: '#fff', fontWeight: 600, // textShadow: '-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black',
                  background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, #000 100%)', pt: 12, pb: 1, borderRadius: { md: '0 0 8px 8px' },
                  width: "100%",
                }}
              >
                <Box component="div" sx={{
                  // flexBasis: 0, flexShrink: 0, flexGrow: 1, display: 'flex', flexDirection: 'column',
                  // justifyContent: 'space-between', zIndex: 1, background: 'transparent',
                }}>
                  <CardContent sx={{ pb: 0 }}>
                    {/* <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                      {post?.frontmatter?.tags?.map(d =>
                        d && d === 'premium' ?
                          <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
                          <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />)}
                      {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', }} />}
                    </Stack> */}
                    <Typography variant="h6" component="div" color="#fff"
                      sx={{
                        fontWeight: 600, fontSize: '24px', lineHeight: 1,
                      }}
                    >
                      {post?.frontmatter?.title}
                    </Typography>
                    <Typography variant="body1" color="#fbfbfc"  // color="text.secondary"
                      sx={{
                        fontSize: '.97rem', display: '-webkit-box', mt: 2, mb: 1,
                        WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis',
                      }}
                    >
                      {post?.frontmatter?.description}
                    </Typography>
                  </CardContent>
                  <Box component="div" sx={{ mx: 1 }}>
                    <CardActions sx={{}}>
                      <Typography variant="caption" sx={{ fontSize: '.8rem', }} color="#fff">
                        {getDate(post?.frontmatter?.date)}
                      </Typography>
                    </CardActions>
                  </Box>
                </Box>
              </Box>
            </CardMedia>
          </StyledCard>
        </Link>
      </Grid >
    </>
  )
}
